import { JobType } from 'components/account/jobs/job_type';
import { JobTypeMappings } from 'components/account/jobs/utils';
import { capitalize } from 'utils/format';
export const jobsOptions = {
    tableView: [
        { id: 1, name: 'List' },
        { id: 2, name: 'With Selfies' },
        { id: 3, name: 'With Ids' }
    ],
    type: [
        {
            id: JobType.idVerification,
            name: JobTypeMappings[JobType.idVerification]
        },
        { id: JobType.idCrosscheck, name: JobTypeMappings[JobType.idCrosscheck] },
        { id: JobType.idAamva, name: JobTypeMappings[JobType.idAamva] },
        {
            id: JobType.idReverification,
            name: JobTypeMappings[JobType.idReverification]
        },
        { id: JobType.idAml, name: JobTypeMappings[JobType.idAml] },
        { id: JobType.privateSSN, name: JobTypeMappings[JobType.privateSSN] },
        { id: JobType.ecbsvSSN, name: JobTypeMappings[JobType.ecbsvSSN] },
        { id: JobType.dob, name: JobTypeMappings[JobType.dob] },
        {
            id: JobType.selfieVerification,
            name: JobTypeMappings[JobType.selfieVerification]
        },
        {
            id: JobType.tinValidation,
            name: JobTypeMappings[JobType.tinValidation]
        }
    ],
    success: [
        { id: 'false', name: 'None' },
        { id: 'true', name: 'Only' }
    ],
    is_disabled: [
        { id: 'true', name: 'Disabled' },
        { id: 'false', name: 'Enabled' }
    ],
    sortBy: [
        { id: 'submitted', name: 'Created' },
        { id: 'updated', name: 'Updated' },
        { id: 'status', name: 'Status' }
    ],
    accountReviewed: [
        { id: 'false', name: 'None' },
        { id: 'true', name: 'Only' }
    ],
    status: [
        { id: 'active', name: 'Active' },
        { id: 'completed', name: 'Completed' },
        { id: 'removed', name: 'Removed' }
    ],
    sortOrder: [
        { id: 'desc', name: 'Desc' },
        { id: 'asc', name: 'Asc' }
    ],
    billableType: [
        { id: 'idv_billable', name: 'Idv' },
        { id: 'physical_address_billable', name: 'Physical Address' },
        { id: 'ip_address_billable', name: 'Ip Address' },
        { id: 'crosscheck_billable', name: 'Crosscheck' },
        { id: 'darkweb_billable', name: 'Darkweb' },
        { id: 'aamva_billable', name: 'Aamva' },
        { id: 'aml_billable', name: 'Aml' }
    ],
    billable: [
        { id: 'true', name: 'Billable' },
        { id: 'false', name: 'Not Billable' }
    ],
    aamvaSource: [
        { id: 'US', name: 'USA' },
        { id: 'CA', name: 'CANADA' }
    ],
    pageSize: [
        { id: 10, name: '10' },
        { id: 25, name: '25' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
        { id: 250, name: '250' },
        { id: 500, name: '500' }
    ],
    amLJobs: [
        { id: 'sanction', name: 'Sanction' },
        { id: 'warning', name: 'Warning' },
        { id: 'pep', name: 'Politically Exposed Person (PEP)' },
        { id: 'all', name: 'All' }
    ]
};
export const humanIdType = (s) => {
    if (!s) {
        return null;
    }
    return s
        .split('-')
        .map((m) => {
        return capitalize(m);
    })
        .join(' ');
};
const ImageMap = {
    id: {
        url: 'idPhotoUrl',
        dimensions: 'idPhotoDimensions'
    },
    user: {
        url: 'userPhotoUrl',
        dimensions: 'userPhotoDimensions'
    },
    backId: {
        url: 'backIdPhotoUrl',
        dimensions: 'backIdPhotoDimensions'
    },
    userDistance: {
        url: 'userDistancePhotoUrl',
        dimensions: 'userDistanceDimensions'
    },
    idDistance: {
        url: 'idDistancePhotoUrl',
        dimensions: 'idDistanceDimensions'
    },
    idDetect: {
        url: 'idPhotoDetectUrl',
        dimensions: 'idPhotoDetectDimensions'
    },
    userDetect: {
        url: 'userPhotoDetectUrl',
        dimensions: 'userPhotoDetectDimensions'
    },
    source: {
        url: 'sourceUrl',
        dimensions: 'sourceDimensions'
    },
    dest: {
        url: 'destUrl',
        dimensions: 'destDimensions'
    }
};
export const createImages = (parameters, imageNames) => {
    return imageNames
        .map((img) => {
        const subImg = ImageMap[img];
        if (!subImg) {
            return null;
        }
        const { url, dimensions } = subImg;
        if (parameters[url]) {
            const d = parameters[dimensions] ?? { width: 1024, height: 1024 };
            return { url: parameters[url], dimensions: d };
        }
        return null;
    })
        .filter(Boolean);
};
export const colors = {
    red: '#FC1B4E',
    black: '##110341',
    blue: '#0D6EBA',
    lightBlue: '#87D0FF',
    neonGreen: '#4DD08B',
    green: '#4FA051',
    lightYellow: 'rgba(254, 196, 9, 0.4)',
    gray: 'rgba(0, 0, 0, 0.4)',
    lightGray: 'rgba(0, 0, 0, 0.1)',
    lighterGray: 'rgba(0, 0, 0, 0.05)'
};
export const cleanArray = (arrayVal, type) => {
    if (!arrayVal) {
        return [' '];
    }
    return arrayVal.map((x) => {
        if (type === 'warnings' && x.suggestion) {
            return `Name Match is below threshold. Suggestion - ${x.suggestion}`;
        }
        return x.message;
    });
};
/**
 * Template the job was matched to: the selected one (Google's or Textract's
 * template), falling back to Google's for jobs processed before selection.
 */
export const getSelectedTemplateId = (debugResults) => {
    const docengine = debugResults?.results?.[0]?.result
        ?.id?.docengine;
    const templateId = docengine?.selection?.templateId ?? docengine?.google?.detect?.id;
    return templateId === undefined ? undefined : String(templateId);
};
